var exports = {
  "YL": "Tooltip.module__tooltip___ODVRYk",
  "xQ": "Tooltip.module__tooltipPointer___ODVRYk",
  "rv": "Tooltip.module__tooltipContent___ODVRYk",
  "iU": "Tooltip.module__tooltipContentLarge___ODVRYk" + " " + "Tooltip.module__tooltipContent___ODVRYk",
  "dn": "Tooltip.module__tooltipTop___ODVRYk",
  "L_": "Tooltip.module__tooltipBottom___ODVRYk",
  "Lf": "Tooltip.module__tooltipLeft___ODVRYk",
  "Uu": "Tooltip.module__tooltipRight___ODVRYk",
  "A4": "Tooltip.module__tooltipPrimary___ODVRYk",
  "yH": "Tooltip.module__tooltipPointerBg___ODVRYk",
  "Rp": "Tooltip.module__tooltipRed___ODVRYk",
  "vX": "Tooltip.module__tooltips___ODVRYk",
  "bZ": "Tooltip.module__hoverFloatingTooltipSurface___ODVRYk",
  "IM": "Tooltip.module__triggerWrapper___ODVRYk",
};

module.exports = exports;
